// removed by extract-text-webpack-plugin
module.exports = {"btn-signup":"summarybutton-module__btn-signup___1HA4M","ease-label":"summarybutton-module__ease-label___3GGxk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/summarybutton.module.scss
// module id = 83
// module chunks = 1